import React from 'react';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import { minMaxValidator } from '../../utils/validators';
import CurrencyField from '../CurrencyField';
import formatPercentage from '../../utils/formatters/formatPercentage';
import Field from '../Field';
import HelpPopover from '../HelpPopover';
import PercentageField from '../PercentageField';
import MobileCarComponent from './MobileCarComponent';

const popoverMessages = {
  priceOfCar: {
    title: 'Price of Car',
    body: [
      'Enter the total sales price, but do not include registration, delivery costs, or other costs that are due up front.'
    ]
  },
  loanTerm: {
    title: 'Loan Term',
    body: [
      'Number of months it will take to pay off the loan.'
    ]
  },
  monthlyPayment: {
    title: 'Monthly Payment',
    body: [
      'Your monthly car payment (does not include insurance or maintenance).'
    ]
  }
};

function CarComparisonGroup({ children, ...inputProps }) {
  const isMobile = useMediaQuery({query: '(max-width: 768px)'});

  const calculatedCar1Payment = inputProps.calculatePayment(inputProps.comparisonCar1.priceOfCar, inputProps.comparisonCar1.loanTerm, inputProps.comparisonCar1.interestRate);
  const calculatedCar2Payment = inputProps.calculatePayment(inputProps.comparisonCar2.priceOfCar, inputProps.comparisonCar2.loanTerm, inputProps.comparisonCar2.interestRate);
  const calculatedCar3Payment = inputProps.calculatePayment(inputProps.comparisonCar3.priceOfCar, inputProps.comparisonCar3.loanTerm, inputProps.comparisonCar3.interestRate);

  return (
    <div className="comparison-group">
      {inputProps.label && (<div className="header-label">{inputProps.label}</div>)}
      {inputProps.subLabel && (<div className="sub-label">{inputProps.subLabel}</div>)}

      { isMobile ? (
        <div>
          <MobileCarComponent
            carNum={1}
            car={inputProps.comparisonCar1}
            handleComparisonChange={inputProps.handleComparisonChange}
            calculatePayment={inputProps.calculatePayment}
            onValidation={inputProps.onValidation}
            loanTermOptions={inputProps.loanTermOptions}
          />

          <MobileCarComponent
              carNum={2}
              car={inputProps.comparisonCar2}
              handleComparisonChange={inputProps.handleComparisonChange}
              calculatePayment={inputProps.calculatePayment}
              onValidation={inputProps.onValidation}
              loanTermOptions={inputProps.loanTermOptions}
          />

          <MobileCarComponent
              carNum={3}
              car={inputProps.comparisonCar3}
              handleComparisonChange={inputProps.handleComparisonChange}
              calculatePayment={inputProps.calculatePayment}
              onValidation={inputProps.onValidation}
              loanTermOptions={inputProps.loanTermOptions}
          />
        </div>
      ) : (
        <div>
          <Row>
            <Col xs={12}>
              <ControlLabel>Price of car</ControlLabel>
              <HelpPopover popover={popoverMessages.priceOfCar} />
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <CurrencyField
                name="comparisonCar1.priceOfCar"
                value={inputProps.comparisonCar1.priceOfCar}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar1', 'priceOfCar') }
              />
            </Col>
            <Col xs={4}>
              <CurrencyField
                name="comparisonCar2.priceOfCar"
                value={inputProps.comparisonCar2.priceOfCar}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar2', 'priceOfCar') }
              />
            </Col>
            <Col xs={4}>
              <CurrencyField
                name="comparisonCar3.priceOfCar"
                value={inputProps.comparisonCar3.priceOfCar}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar3', 'priceOfCar') }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <ControlLabel>Loan term (in months)</ControlLabel>
              <HelpPopover popover={popoverMessages.loanTerm} />
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <Field
                type="select"
                name="comparisonCar1.loanTerm"
                value={inputProps.comparisonCar1.loanTerm}
                choices={inputProps.loanTermOptions}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar1', 'loanTerm') }
              />
            </Col>
            <Col xs={4}>
              <Field
                  type="select"
                  name="comparisonCar2.loanTerm"
                  value={inputProps.comparisonCar2.loanTerm}
                  choices={inputProps.loanTermOptions}
                  onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar2', 'loanTerm') }
              />
            </Col>
            <Col xs={4}>
              <Field
                  type="select"
                  name="comparisonCar3.loanTerm"
                  value={inputProps.comparisonCar3.loanTerm}
                  choices={inputProps.loanTermOptions}
                  onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar3', 'loanTerm') }
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <ControlLabel>Interest rate</ControlLabel>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <PercentageField
                name="comparisonCar1.interestRate"
                value={inputProps.comparisonCar1.interestRate}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar1', 'interestRate') }
                validator={minMaxValidator(0.01, 99.99, formatPercentage)}
                onValidation={inputProps.onValidation}
              />
            </Col>
            <Col xs={4}>
              <PercentageField
                name="comparisonCar2.interestRate"
                value={inputProps.comparisonCar2.interestRate}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar2', 'interestRate') }
                validator={minMaxValidator(0.01, 99.99, formatPercentage)}
                onValidation={inputProps.onValidation}
              />
            </Col>
            <Col xs={4}>
              <PercentageField
                name="comparisonCar3.interestRate"
                value={inputProps.comparisonCar3.interestRate}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar3', 'interestRate') }
                validator={minMaxValidator(0.01, 99.99, formatPercentage)}
                onValidation={inputProps.onValidation}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <ControlLabel>Monthly payment</ControlLabel>
              <HelpPopover popover={popoverMessages.monthlyPayment} />
            </Col>
          </Row>
          <Row>
            <Col xs={4}>
              <CurrencyField
                name="comparisonCar1.monthlyPayment"
                value={inputProps.comparisonCar1.monthlyPayment}
                calculatedValue={calculatedCar1Payment}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar1', 'monthlyPayment') }
                onValidation={inputProps.onValidation}
                disabled={true}
              />
            </Col>
            <Col xs={4}>
              <CurrencyField
                name="comparisonCar2.monthlyPayment"
                value={inputProps.comparisonCar2.monthlyPayment}
                calculatedValue={calculatedCar2Payment}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar2', 'monthlyPayment') }
                onValidation={inputProps.onValidation}
                disabled={true}
              />
            </Col>
            <Col xs={4}>
              <CurrencyField
                name="comparisonCar3.monthlyPayment"
                value={inputProps.comparisonCar3.monthlyPayment}
                calculatedValue={calculatedCar3Payment}
                onChange={(e, value) => inputProps.handleComparisonChange(value, 'comparisonCar3', 'monthlyPayment') }
                onValidation={inputProps.onValidation}
                disabled={true}
              />
            </Col>
          </Row>
        </div>
      )}
    </div>
  )
}

export default CarComparisonGroup



// WEBPACK FOOTER //
// ./src/components/CarComparisonGroup/index.js